module.exports = __webpack_public_path__ + "static/media/1.ffde5256.JPG";